/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="73.27"
        height="84.13"
        viewBox="0 0 73.27 84.13"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M21.61 32.4a1.25 1.25 0 0 1 0 2.5 7.18 7.18 0 0 0-1.9.25c-6.32 1.75-9.72 11.76-7.08 21.91a1.26 1.26 0 0 1-.9 1.53 1.25 1.25 0 0 1-1.52-.9c-2.96-11.32.95-22.76 8.83-24.94a9.7 9.7 0 0 1 2.57-.35ZM52.02 4.75a1.25 1.25 0 0 1 0 2.5 14.13 14.13 0 0 0-14.13 13.78v6.38a1.25 1.25 0 0 1-2.49.13v-6.2A16.64 16.64 0 0 1 52.02 4.75Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="m36.63 29.27-.14-.12c-6-5.14-13.17-7.17-19.91-5.3C3.78 27.39-2.98 43.61 1.25 60.01s18 27 30.8 23.43l.5-.14a19.23 19.23 0 0 0 3.82-1.68l.24-.15.25.15a18.58 18.58 0 0 0 4.31 1.82c12.82 3.55 26.55-7 30.81-23.43s-2.49-32.62-15.29-36.16c-6.74-1.87-13.94.16-19.91 5.3Zm19.39-3c11.33 3.13 17.5 17.93 13.56 33.12S53.17 84.17 41.86 81.04a16.31 16.31 0 0 1-4.55-2.08 1.27 1.27 0 0 0-1.35 0 16.57 16.57 0 0 1-4.55 2.08C20.1 84.17 7.63 74.56 3.69 59.39s2.23-30 13.55-33.12c6.23-1.73 13 .37 18.54 5.61a1.25 1.25 0 0 0 1.71 0c5.56-5.25 12.31-7.35 18.53-5.62Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M21.25 0h-3.84a1.25 1.25 0 0 0-1.25 1.25v3.84a16.63 16.63 0 0 0 16.63 16.66h3.84a1.25 1.25 0 0 0 1.25-1.25v-3.87A16.63 16.63 0 0 0 21.25 0Zm-2.6 2.5h2.91a14.13 14.13 0 0 1 13.82 14.13v2.59h-2.59A14.13 14.13 0 0 1 18.66 5.09Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'AppleWithStemIcon';

export default Icon;
